import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons';

import { Box } from '../Box/Box';

import * as style from './ClearButton.css';

export const ClearButton = ({
  onClick,
  disabled,
}: {
  onClick: () => void;
  disabled?: boolean;
}): JSX.Element => {
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      tabIndex={-1}
      margin="none"
      padding="medium"
      cursor="pointer"
      className={style.ClearButton}
      disabled={disabled}
    >
      <FontAwesomeIcon size="xl" icon={faTimesCircle} />
    </Box>
  );
};
